import React, { useContext, useEffect, useRef, useState } from "react";
import "../../css_files/Homepage/Table.css";
import Swal from "sweetalert2";
import axios from "axios";
import { toast } from "react-toastify";
import { triggerscroll } from "./Homepage";
import axiosInstance from "../../api";

function Table({
  tablehead,
  tabledata,
  setshowaddform,
  settriggerupdate,
  fetchdata,
  url,
  reload,
  setReload,
  setdatareload,
  datareload,
  loading,
  readPermission,
  updatePermission,
  deletePermission,
  totalcount,
}) {
  const { triggerscrollupwords, triggerscrolldownwords } =
    useContext(triggerscroll);
  const tableRef = useRef();
  const [deleteLoader, setDeleteLoader] = useState([]);

  useEffect(() => {
    setDeleteLoader(Array.from({ length: tabledata?.length }, () => false));
  }, [tabledata?.length]);

  function handleDelete(id, index) {
    setDeleteLoader((prev) => prev.map((_, i) => i === index));
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/${url}`;
    axiosInstance
      .post(URL, {
        Id: id,
        HSNId: id,
        UnitID: id,
        PackingID: id,
        CustomerID: id,
        TechnicianID: id,
        isDeleted: true,
      })
      .then((res) => {
        toast.success("Record Deleted Successfully", {
          position: "bottom-center",
          theme: "dark",
        });
        setReload(!reload);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          position: "bottom-center",
          theme: "dark",
        });

        if (err.response.status === 409) {
          Swal.fire({
            icon: "info",
            text: err.response.data,
          });
        }
      })
      .finally(() => {
        setDeleteLoader((prev) => prev.map((_) => false));
      });
  }
  return (
    <>
      <blockquote className="navigate-left-right-bottom-table">
        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: -tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </button>
        <p style={{ fontSize: "1.2rem" }}>{totalcount} Records</p>
        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-right"></i>
        </button>
      </blockquote>
      <section className="table" ref={tableRef}>
        <section>
          <div>
            <aside
              style={{
                gridTemplateColumns: `repeat(${tablehead.length * 2 + 1}, 1fr)`,
              }}
            >
              {tablehead.map((head, index) => (
                <blockquote
                  key={index}
                  style={{
                    minWidth: index === 0 ? "5rem" : "15rem",
                    gridColumn: index !== 0 && "span 2",
                  }}
                >
                  <center>{head}</center>
                </blockquote>
              ))}

              <blockquote style={{ gridColumn: "span 2", minWidth: "6rem" }}>
                Actions
              </blockquote>
            </aside>
          </div>
          <div>
            <figure>
              {readPermission() ? (
                loading ? (
                  <aside
                    style={{
                      gridTemplateColumns: `repeat(${
                        tablehead.length * 2 + 1
                      }, 1fr)`,
                    }}
                  >
                    <blockquote
                      style={{ gridColumn: `span ${tablehead.length * 2 + 1}` }}
                    >
                      <center>
                        <i
                          class="fa-solid fa-rotate-right fa-spin"
                          style={{ fontSize: "2.5rem" }}
                        ></i>
                      </center>
                    </blockquote>
                  </aside>
                ) : tabledata.length > 0 ? (
                  tabledata.map((data, index) => (
                    <aside
                      key={index}
                      style={{
                        gridTemplateColumns: `repeat(${
                          tablehead.length * 2 + 1
                        }, 1fr)`,
                      }}
                    >
                      {data.map((tdata, idx) => (
                        <blockquote
                          key={idx}
                          style={{
                            minWidth: idx === 0 ? "5rem" : "15rem",
                            gridColumn: idx !== 0 && "span 2",
                          }}
                        >
                          {tdata === "Tap here to See More Details" ? (
                            <center>
                              <a
                                href="#"
                                onClick={() => {
                                  fetchdata(tabledata[index][0], true);
                                }}
                              >
                                {tdata}
                              </a>
                            </center>
                          ) : (
                            <center>
                              <p>{tdata}</p>
                            </center>
                          )}
                        </blockquote>
                      ))}
                      <blockquote style={{ minWidth: "3rem" }}>
                        <i
                          className="fa-regular fa-pen-to-square"
                          style={{
                            pointerEvents: updatePermission() && "none",
                            color: updatePermission() && "gray",
                            cursor: updatePermission() && "not-allowed",
                          }}
                          onClick={() => {
                            setdatareload(datareload + 1);
                            setshowaddform(true);
                            settriggerupdate(true);
                            triggerscrollupwords();
                            fetchdata(tabledata[index][0]);
                          }}
                          title="Edit"
                        />
                      </blockquote>
                      <blockquote style={{ minWidth: "3rem" }}>
                        {deleteLoader[index] ? (
                          <i
                            class="fa-solid fa-hurricane fa-spin"
                            title="Please Wait..."
                          ></i>
                        ) : (
                          <i
                            className="fa-solid fa-trash"
                            title="Delete"
                            style={{
                              pointerEvents: deletePermission() && "none",
                              color: deletePermission() && "gray",
                              cursor: deletePermission() && "not-allowed",
                            }}
                            onClick={() => {
                              Swal.fire({
                                title: "Are you sure?",
                                text: "You won't be able to revert this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, delete it!",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  handleDelete(tabledata[index][0], index);
                                }
                              });
                            }}
                          />
                        )}
                      </blockquote>
                    </aside>
                  ))
                ) : (
                  <aside
                    style={{
                      gridTemplateColumns: `repeat(${
                        tablehead.length * 2 + 1
                      }, 1fr)`,
                    }}
                  >
                    <blockquote
                      style={{ gridColumn: `span ${tablehead.length * 2 + 1}` }}
                    >
                      <center>No Records Available</center>
                    </blockquote>
                  </aside>
                )
              ) : (
                <aside
                  style={{
                    gridTemplateColumns: `repeat(${
                      tablehead.length * 2 + 1
                    }, 1fr)`,
                  }}
                >
                  <blockquote
                    style={{ gridColumn: `span ${tablehead.length * 2 + 1}` }}
                  >
                    <center>You do not have permission to read data</center>
                  </blockquote>
                </aside>
              )}
            </figure>
          </div>
        </section>
      </section>
    </>
  );
}

export default Table;
